export default function SyntheseModelesConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('synthesemodeles');
    $translatePartialLoaderProvider.addPart('synthesetype');
}

SyntheseModelesConfiguration.$inject = ['$translatePartialLoaderProvider'];
